import { apiRequest } from '@/utils/api-request';
import { useOrgStore } from '@/stores/org-store';
import type { SkillListResponse } from './types';

export const listSkills = async (): Promise<SkillListResponse> => {
  const { currentOrg } = useOrgStore.getState();
  const orgId = currentOrg?.orgid;
  if (!orgId) throw new Error('No organization selected');

  const response = await apiRequest<SkillListResponse>({
    url: `/skills/${orgId}`,
    method: 'GET',
    target: 'platform',
  });

  if (response.detail) {
    throw new Error(response.detail);
  }

  return response.data ?? { skills: [], count: 0 };
};
